import classnames from 'classnames';
import Button from 'components/Button';

import Checkbox from 'components/Checkbox';
import Field from 'components/Field';
import Loading from 'components/Loading';
import Modal from 'components/Modal';
import { Map } from 'immutable';
import { get, identity } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Collapse from 'react-collapse';
import { routeMap } from 'router';
import { getLoginIfExists } from '../../utils/loginSaver/index';
import ChangePassword from './private/ChangePassword';
import ESAuth from './private/ESAuth';
import ResetPassword from './private/ResetPassword';
import { Link } from 'redux-little-router';
import { scroller } from 'react-scroll';
import NumberFormat from 'react-number-format';
import ConfigWrapper from 'containers/ConfigWrapper';
import errorMessages from '../../../../constants/errorMessages';
import config from 'config';
import styles from './AuthorizationPage.module.scss';
import REACT_CONFIG from 'REACT_CONFIG';

const authErrorCode = 400;
const internalServerError = 500;
const incorrectCaptchaCode = 401;
const captchaErrorCode = 429;
const scrollDuration = 500;
const scrollWrapperId = 'scroll-wrapper';
const authErrorMap = {
  invalid_request: 'Вы превысили количество попыток входа. Попробуйте снова через 24 часа',
  invalid_grant: 'Неверный ИНН/пароль',
  invalidCaptcha: 'Цифры с картинки введены неправильно',
  captchaIsNotPresent: 'Цифры с картинки не введены',
  disabledUser:
    'Пользователь отказался от сервиса. Для повторного подключения обратитесь в ИФНС по месту жительства',
  unauthorized: 'Неверный ИНН/пароль',
};
const captchaErrorMessage = 'incorrect captcha';
const disabledUserErrorMessage = 'user is disabled';

export default class AuthorizationPage extends Component {
  static propTypes = {
    authorization: PropTypes.instanceOf(Map),
    captcha: PropTypes.instanceOf(Map),
    check: PropTypes.instanceOf(Map),
    resetPasswordData: PropTypes.object.isRequired,
  };

  state = {
    showServiceCapabilities: false,
    showServiceAccessInfo: false,
    rememberMe: !!getLoginIfExists(),
    captchaValue: '',
    showCaptcha: false,
    loginStarted: false,
    submitError: '',
    showResetPasswordModal: false,
    showChangePasswordModal: false,
    showESAuth: false,
    firstShowChangePassword: true,
    showInfoModal: false,
    infoModalText: '',
    passwordType: 'password',
    showPasswordButton: false,
    showTemporaryBanner: false,
    temporaryBannerContent: '',
    checkingLoading: false,
    techWorkBanner: true,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { authorization: currentAuthorization } = this.props;
    const { authorization } = nextProps;
    const { showCaptcha, loginStarted } = this.state;
    const { error: currentLoginError } = currentAuthorization.toJS();
    const { error: loginError } = authorization.toJS();
    const currentStatusCode = get(currentLoginError, 'response.status', null);
    const statusCode = get(loginError, 'response.status', null);
    const isNewStatusCode = statusCode !== currentStatusCode;
    const hasCaptcha =
      showCaptcha && (statusCode === authErrorCode || statusCode === incorrectCaptchaCode);
    const needLoadCaptcha =
      (isNewStatusCode && statusCode === captchaErrorCode) || (hasCaptcha && loginStarted);

    if (needLoadCaptcha) {
      this.getCaptcha(this.usernameInput.value);
      this.setState({ showCaptcha: true, loginStarted: false, captchaValue: '' });
    }
  }

  setRememberMe = (value) => {
    this.setState({
      rememberMe: value,
    });
  };

  onChangeCaptcha = (value) => {
    const regex = /[^A-Za-z0-9]+/;
    const captchaValue = value.replace(regex, '');

    this.setState({ captchaValue });
  };

  getErrorMessage(loginError) {
    if (!loginError) {
      return null;
    }
    const error = get(loginError, 'response.data.error', null);
    const description = get(loginError, 'response.data.error_description', '') || '';
    const errorMessage = get(loginError, 'response.data.message', '') || '';
    const errorExtMessage = get(loginError, 'response.data.extMessage', '') || '';
    const code = get(loginError, 'response.status', null);
    let message = '';

    if (code === authErrorCode || code === incorrectCaptchaCode) {
      message = authErrorMap[error] || null;
      if (description.toLowerCase() === disabledUserErrorMessage) {
        message = authErrorMap.disabledUser;
      }
    }

    if (code === incorrectCaptchaCode && captchaErrorMessage === errorMessage.toLowerCase()) {
      message = authErrorMap.invalidCaptcha;
    }

    if (code === internalServerError) {
      message = errorMessages.serverErrorWithOutLinks;
    }

    return errorExtMessage || message;
  }

  getUniqueName(prefix) {
    const uniqueId = new Date().getTime().toString(16);

    return `${prefix}_${uniqueId}`;
  }

  getCaptcha() {}

  showResetPasswordModal = () => this.setState({ showResetPasswordModal: true });
  hideResetPasswordModal = () => this.setState({ showResetPasswordModal: false });
  hideChangePasswordModal = () => this.setState({ showChangePasswordModal: false });
  showInfoModal = (text) => this.setState({ showInfoModal: true, infoModalText: text });
  hideInfoModal = () => this.setState({ showInfoModal: false });
  showESAuthModal = () => this.setState({ showESAuth: true });
  hideESAuthModal = () => this.setState({ showESAuth: false });

  togglePasswordType = () =>
    this.setState({ passwordType: this.state.passwordType === 'password' ? 'text' : 'password' });

  toggleShowServiceAccessInfo = () => {
    this.setState({
      showServiceAccessInfo: !this.state.showServiceAccessInfo,
    });
  };

  toggleShowServiceCapabilities = () => {
    this.setState({
      showServiceCapabilities: !this.state.showServiceCapabilities,
    });
  };

  onSubmit = (e) => {
    const { authorization } = this.props;
    const noCaptcha = this.state.showCaptcha && !this.state.captchaValue;
    e.preventDefault();

    if (noCaptcha) {
      this.setState({ submitError: authErrorMap.captchaIsNotPresent });
    }

    if (authorization.get('loading') || noCaptcha) {
      return;
    }

    this.setState({ loginStarted: true, submitError: '' }, () => {
      this.authorize();
    });
  };

  getTemporaryModalContent = () => {
    const { temporaryBannerContent } = this.state;

    return (
      <Modal
        className={styles.markupModal}
        horizontalCentering={true}
        hasCloseIcon={false}
        type={'medium'}
        popupWrapperStyle={{
          borderRadius: '10px',
          padding: '30px',
        }}
        showModal={this.state.techWorkBanner}
      >
        <div className="boo">
          <div className="row">
            <div
              className={`col ${styles.techWorkModal__innerText} ${styles.preWrap}`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: temporaryBannerContent }}
            />
          </div>
          <div className="row justify-content-end">
            <div className="col-sm-auto col">
              <Button
                extraClassName={'button__100'}
                color="orange"
                hasWrapper={false}
                onClick={this.handleCloseTechWork}
              >
                Закрыть
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  };
  handleCloseTechWork = (e) => {
    e.preventDefault();
    this.setState({ techWorkBanner: false });
  };
  handleClickToStartPage = () => {
    this.setState({ showResetPasswordModal: false, showServiceAccessInfo: true });

    scroller.scrollTo('serviceAccessInfo', {
      containerId: scrollWrapperId,
      duration: scrollDuration,
      smooth: true,
      ignoreCancelEvents: true,
    });
  };

  ESAuthorize() {}

  showAccessibilityModal() {}

  startWorking() {}

  authorize() {}

  renderFakePasswordFields = () => {
    const values = ['a', 'b', 'c', 'd'];

    return values.map((value, key) => {
      return (
        <input
          key={`${value}_${key}`}
          type="password"
          style={{ position: 'absolute', left: '-10000px' }}
          defaultValue={value}
          name={this.getUniqueName(value)}
          aria-hidden="true"
          tabIndex="-1"
        />
      );
    });
  };
  renderCaptcha = () => {
    if (!this.state.showCaptcha) {
      return null;
    }
    const { captcha } = this.props;
    const { data, loading } = captcha.toJS();

    return (
      <div className="cRow">
        <div className="cCol">
          <div style={{ minHeight: '50px' }}>
            {loading ? (
              <div className="loading-container loading-container__middle">
                <Loading />
              </div>
            ) : (
              <img src={data} alt="" />
            )}
          </div>
          <Field
            label="Цифры с картинки"
            value={this.state.captchaValue}
            maxLength={6}
            onChange={(e) => this.onChangeCaptcha(e.target.value)}
          />
        </div>
      </div>
    );
  };

  renderShowServiceCapabilities() {
    const { showServiceCapabilities } = this.state;

    return (
      <div className="drop_item js-drop-parent boo">
        <div className={styles.dropTitleRelative}>
          <div className={styles.demoButton}>{this.renderDemoButton()}</div>

          <div
            onClick={this.toggleShowServiceCapabilities}
            className={classnames('drop_button', 'js-drop-btn', {
              active: showServiceCapabilities,
            })}
          >
            <div className="drop_icon" />
            <div className="drop_title">Возможности сервиса</div>
          </div>
        </div>
        <Collapse className="drop_block js-drop-block" isOpened={showServiceCapabilities}>
          <ul className="list mt-4">
            <li>
              Получать актуальную информацию об объектах имущества и транспортных средствах, о
              суммах начисленных и уплаченных налоговых платежей, о наличии переплат, о
              задолженности по налогам перед бюджетом.
            </li>
            <li>Контролировать состояние расчетов с бюджетом.</li>
            <li>
              Получать и распечатывать налоговые уведомления и квитанции на оплату налоговых
              платежей.
            </li>
            <li>
              Оплачивать налоговую задолженность и налоговые платежи через банки – партнеры ФНС
              России.
            </li>
            <li>
              Заполнять декларацию по форме № 3-НДФЛ в режиме онлайн, направлять в налоговый орган
              декларацию по форме № 3-НДФЛ в электронном виде, подписанную электронной подписью
              налогоплательщика.
            </li>
            <li>Отслеживать статус камеральной проверки налоговых деклараций по форме № 3-НДФЛ.</li>
            <li>Обращаться в налоговые органы без личного визита в налоговый орган.</li>
            <li>
              Получать свидетельство о постановке на учет в налоговом органе (содержащее сведения об
              ИНН) в электронном виде.
            </li>
            <li>Получать сведения о своих счетах (вкладах) в Российских банках.</li>
          </ul>
        </Collapse>
      </div>
    );
  }

  renderDemoButton() {
    if (!config.isDemoMode) {
      return (
        REACT_CONFIG.REACT_APP_DEMO_PATH && (
          <a
            href={REACT_CONFIG.REACT_APP_DEMO_PATH}
            className="button button__medium button__white__100 button__white__outline-white"
          >
            Демо-версия
          </a>
        )
      );
    }
    return (
      REACT_CONFIG.REACT_APP_PRIMARY_PATH && (
        <a
          href={REACT_CONFIG.REACT_APP_PRIMARY_PATH}
          className="button button__medium button__white__100 button__white__outline-white"
        >
          Полная версия
        </a>
      )
    );
  }

  renderShowServiceAccessInfo() {
    const { showServiceAccessInfo } = this.state;

    return (
      <div className="drop_item js-drop-parent" id={'serviceAccessInfo'}>
        <div
          onClick={this.toggleShowServiceAccessInfo}
          className={classnames('drop_button', 'js-drop-btn', {
            active: showServiceAccessInfo,
          })}
        >
          <div className="drop_icon" />
          <div className="drop_title">Как получить доступ к сервису</div>
        </div>
        <Collapse className="drop_block js-drop-block" isOpened={showServiceAccessInfo}>
          <p>
            Доступ к сервису «Личный кабинет налогоплательщика для физических лиц» осуществляется
            одним из трех способов:
          </p>
          <ul className="list">
            <li>
              С помощью логина и пароля, указанных в регистрационной карте.&nbsp;
              {!REACT_CONFIG.REACT_APP_HIDE_EXTERNAL_APPOINTMENT ? (
                <Link className={'white link link__underline'} href={routeMap.externalAppointment}>
                  Получить регистрационную карту
                </Link>
              ) : (
                'Получить регистрационную карту'
              )}{' '}
              вы можете лично в любом налоговом органе России, независимо от места постановки на
              учет. При обращении в налоговый орган России при себе необходимо иметь документ,
              удостоверяющий личность. Получение доступа к сервису для лиц, не достигших 14 лет,
              осуществляется законными представителями (родителями, усыновителями, опекунами) при
              условии предъявления свидетельства о рождении (иного документа, подтверждающего
              полномочия) и документа, удостоверяющего личность представителя.
            </li>
            <li>
              Если логин и пароль были Вами получены ранее, но Вы их утратили, следует обратиться в
              любой налоговый орган России с документом, удостоверяющим личность.
            </li>
            <li>
              С помощью квалифицированной электронной подписи. Квалифицированный сертификат ключа
              проверки электронной подписи должен быть выдан Удостоверяющим центром, аккредитованным
              Минцифры России и может храниться на любом носителе: жестком диске, USB-ключе или
              смарт-карте. При этом требуется использование специального программного
              обеспечения-криптопровайдера: CryptoPro CSP версии 4.0 и выше для работы по ГОСТ 2012
              года.
            </li>
            <li>
              С помощью учетной записи Единой системы идентификации и аутентификации (ЕСИА) –
              реквизитов доступа, используемых для авторизации на Едином портале государственных и
              муниципальных услуг. Внимание! Авторизация возможна только для пользователей, которые
              обращались для получения реквизитов доступа лично в одно из мест присутствия
              операторов ЕСИА (отделения Почты России, МФЦ и др.)
            </li>
          </ul>
        </Collapse>
      </div>
    );
  }

  renderLinksToStores = () => {
    const linkToAppStore =
      'https://itunes.apple.com/ru/app/%D0%BD%D0%B0%D0%BB%D0%BE%D0%B3%D0%B8-%D1%84%D0%BB/id1286819946?mt=8';
    return (
      <p>
        Мобильное приложение доступно для скачивания в&nbsp;
        <a
          href="https://play.google.com/store/apps/details?id=ru.fns.lkfl"
          target="_blank"
          className="white link link__underline"
        >
          Google Play
        </a>{' '}
        и&nbsp;
        <a href={linkToAppStore} target="_blank" className="white link link__underline">
          App Store
        </a>
      </p>
    );
  };

  renderLoginPage() {
    const { authorization } = this.props;
    const { error: loginError, loading } = authorization.toJS();
    const errorMessage = this.state.submitError || this.getErrorMessage(loginError);
    const loginValue = getLoginIfExists();
    const LoginCertLink = ConfigWrapper(
      <a className="js-popap" key={'RF_LOGIN_CERT'} onClick={this.showESAuthModal}>
        Войти с помощью ЭП
      </a>,
    );
    const LoginEsiaLink = ConfigWrapper(
      <a key={'RF_LOGIN_ESIA'} href={routeMap.esiaRedirect}>
        Войти через госуслуги (ЕСИА)
      </a>,
    );
    return (
      <div className="main-page_row main-page_row__small">
        <div className="white-block main-page_form">
          <h2>Вход в личный кабинет</h2>
          <form
            className={classnames('form', { 'form__full-error': errorMessage })}
            autoComplete="off"
            ref={(f) => (this.form = f)}
            onSubmit={this.onSubmit}
          >
            <div key="username" className="form_item">
              <div className="form_label">Логин (Ваш ИНН)</div>
              <div className="form_wrapper">
                <NumberFormat
                  name={this.getUniqueName('u')}
                  getInputRef={(input) => (this.usernameInput = input)}
                  onValueChange={() => {
                    this.setState({ showCaptcha: false });
                  }}
                  type="text"
                  maxLength={12}
                  className="form_field"
                  defaultValue={loginValue}
                  format={identity}
                />
              </div>
            </div>
            <div className="form_item">
              <div className="form_label">Пароль</div>
              <div className="form_wrapper">
                {this.renderFakePasswordFields()}
                <input
                  key="password"
                  name={this.getUniqueName('p')}
                  onChange={() =>
                    this.setState({ showPasswordButton: this.passwordInput.value.length > 0 })
                  }
                  ref={(input) => (this.passwordInput = input)}
                  type={this.state.passwordType}
                  className="form_field"
                />
                {this.state.showPasswordButton ? (
                  <a onClick={this.togglePasswordType}>
                    {this.state.passwordType === 'password' ? 'Показать пароль' : 'Скрыть пароль'}
                  </a>
                ) : null}
              </div>
            </div>
            {this.renderCaptcha()}
            <div className={classnames('form_error', { 'red page_margin20': errorMessage })}>
              {errorMessage || null}
            </div>
            <div className="cRow">
              <div className="cCol cCol__50">
                <div className="form_item">
                  <Button
                    type="submit"
                    color={'orange'}
                    isFullWidth={true}
                    isDisabled={!this.state.showPasswordButton}
                    hasWrapper={false}
                    size={'medium'}
                    isLoading={loading || this.state.checkingLoading}
                  >
                    Войти
                  </Button>
                </div>
              </div>
              <div className="cCol cCol__50">
                <div className="form_item">
                  <div className="form_link">
                    <LoginCertLink />
                  </div>
                  <div className="form_link">
                    <LoginEsiaLink />
                  </div>
                </div>
              </div>
            </div>

            <div className="cRow">
              <div className="cCol  cCol__50">
                <div className="form_item">
                  <Checkbox
                    name="remember_me"
                    label="Запомнить меня"
                    value={this.state.rememberMe}
                    onChange={this.setRememberMe}
                  />
                </div>
              </div>
              <div className="cCol  cCol__50">
                <div className="form_item">
                  <a onClick={this.showResetPasswordModal}>Забыли пароль?</a>
                </div>
              </div>
            </div>

            <input type="hidden" name="dummy" value="1" />
          </form>
        </div>

        <div className="drop">
          {this.renderShowServiceCapabilities()}
          {this.renderShowServiceAccessInfo()}
        </div>
        {this.renderLinksToStores()}
      </div>
    );
  }

  render() {
    const { firstShowChangePassword } = this.state;
    const token = get(this.props.resetPasswordData, 'token', '');

    if (firstShowChangePassword && get(this.props.resetPasswordData, 'resetPassword', false)) {
      this.setState({
        showChangePasswordModal: true,
        firstShowChangePassword: false,
      });
    }

    return [
      this.state.showTemporaryBanner && this.state.temporaryBannerContent
        ? this.getTemporaryModalContent()
        : null,
      <div key="main_page" className="main-page">
        <div className="main-page_bg" />

        <div className="header-wrapper header-wrapper__main">
          <div className="header header__main content">
            <a className="header-title">
              <span className="header-title_icon" />
              <span className="header-title_text">
                Личный кабинет
                <br /> налогоплательщика
              </span>
            </a>

            <div className="header_links__main">
              <a
                className="header_link header_link__eye header_link__mobile js-version-open"
                title="Версия для слабовидящих"
                onClick={() => this.showAccessibilityModal()}
              >
                <span className="replace_text">Вид</span>
              </a>
              <a href="tel:8-800-222-2222" className="phone">
                8-800-222-2222
              </a>
              <span className="white"> Контакт-центр</span>
            </div>
          </div>
        </div>

        <div className="main-page_center">
          <div className="main-page_cell">
            <div className="content">
              {this.props.check.get('loading') ? <Loading /> : this.renderLoginPage()}
            </div>
          </div>
        </div>

        <div className="footer-wrapper">
          <div className="footer footer__main content">
            <div className="footer_left">
              <span className="mobile-hide">
                При наличии вопросов по работе сервиса Вы можете воспользоваться режимом&nbsp;
              </span>
              <Link href={routeMap.faq} className="link white link__underline">
                «Вопрос-ответ»
              </Link>
            </div>
          </div>
        </div>

        <ChangePassword
          token={token}
          onHideModal={this.hideChangePasswordModal}
          showModal={this.state.showChangePasswordModal}
          showInfoMessage={this.showInfoModal}
        />
        <ResetPassword
          onHideModal={this.hideResetPasswordModal}
          showModal={this.state.showResetPasswordModal}
          handleClickToStartPage={this.handleClickToStartPage}
          showInfoMessage={this.showInfoModal}
        />
        <ESAuth
          onAuthorize={this.ESAuthorize.bind(this)}
          showModal={this.state.showESAuth}
          checkSuccess={this.props.authorization.get('checkSuccess')}
          onHideModal={this.hideESAuthModal}
          error={this.props.authorization.get('ESAuthError')}
          errorId={this.props.authorization.get('ESAuthErrorId')}
          onStartWorking={this.startWorking.bind(this)}
          loading={this.props.authorization.get('loading')}
        />
        <Modal type="large" showModal={this.state.showInfoModal} onClose={this.hideInfoModal}>
          <div>
            <h2>Успешно</h2>
            <p>{this.state.infoModalText}</p>
            <Button size="medium" style={{ marginTop: '20px' }} onClick={this.hideInfoModal}>
              Закрыть
            </Button>
          </div>
        </Modal>
      </div>,
    ];
  }
}
